'use strict';
var IS_DENO = require('../internals/engine-is-deno');
var IS_NODE = require('../internals/engine-is-node');

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-is-browser.js
// module id = 399
// module chunks = 0